import React, { useEffect, useState } from "react";
import "./ProfessionalDetailsForm.css";
import FormInputStyle2 from "../../../../components/Form/FormInputStyle2";
import FormSelectStyle2 from "../../../../components/Form/FormSelectStyle2";
import FormButtonStyle2 from "../../../../components/Form/FormButtonStyle2";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { useSearchParams } from "react-router-dom";
import DOMPurify from "dompurify";
import FormInputStyle4 from "../../../DMIFinance/UIElements/FormInput";
import callApi from "../../../../utility/apiCaller";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const ProfessionalDetailsForm = ({ formData, setFormData, setCurrentStep }) => {
  const [companyName, setCompanyName] = useState(formData.companyName || "");
  const [companyType, setCompanyType] = useState(formData.companyType || "");
  const [workEmail, setWorkEmail] = useState(formData.workEmail || "");
  const [pincodeValidation, setpincodeValidation] = useState(false);
  const [monthlyIncome, setMonthlyIncome] = useState(
    formData.monthlyIncome || ""
  );
  const [work_pincode, setwork_pincode] = useState(formData.work_pincode || "");
  const [isFormValid, setIsFormValid] = useState(false);
  const [errors, setErrors] = useState({});
  const [affId, setAffId] = useState("");
  const [params] = useSearchParams();
  const user = useSelector((state) => state.app.user);
  const leadFromStore = useSelector((state) => state?.app?.lead);
  const leadIdFromStore = leadFromStore?.id || leadFromStore?.lead?._id;

  const sanitizeInput = (value) => DOMPurify.sanitize(value);
  const sanitizeCompanyName = (value) => {
    if (!value) return "";

    // First, sanitize for XSS
    let sanitized;

    // Then remove unwanted characters but keep spaces
    sanitized = value
      .replace(/[^a-zA-Z0-9\s.,'&\-()]/g, "")
      .replace(/\s+/g, " ");

    // Trim leading/trailing spaces
    return sanitized;
  };

  const sanitizeAndValidateEmail = (value) => {
    if (!value) return { value: "", isValid: false };

    const sanitized = DOMPurify.sanitize(value).trim();

    // Simple email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(sanitized);

    return { value: sanitized, isValid };
  };

  const handlePincodeChange = async (value) => {
    value = value.replace(/\D/g, ""); // allow only digits

    if (/^\d{0,6}$/.test(value)) {
      // Prevent first digit being 0 if there's at least one digit
      if (value.length > 0 && value[0] === "0") {
        return; // ignore input if first digit is 0
      }

      setwork_pincode(value); // always update input field

      // clear error if user is still typing
      if (errors.pincode) {
        setErrors((prev) => ({ ...prev, pincode: false }));
      }

      // Only validate when user has entered 6 digits
      if (value.length === 6) {
        setpincodeValidation(true); // start loading state

        try {
          // ✅ call your backend API using callApi instead of fetch
          const response = await callApi(
            `v1/util/${value}`, // backend route
            "get", // HTTP method
            {}, // body (not needed for GET)
            "core" // service key
          );

          if (!response.success) {
            setErrors((prev) => ({ ...prev, pincode: true }));
          } else {
            setErrors((prev) => ({ ...prev, pincode: false }));

            console.log("Valid Pincode, City:", response.city);
          }
        } catch (error) {
          console.error("Pincode validation error:", error);
          setErrors((prev) => ({ ...prev, pincode: true }));
        } finally {
          setpincodeValidation(false); // end loading state
        }
      }
    }
  };

  useEffect(() => {
    if (params.get("aff_id")) setAffId(params.get("aff_id"));
  }, [params]);

  const validate = () => {
    const newErrors = {};
    if (!companyName.trim()) newErrors.companyName = true;
    if (!companyType) newErrors.companyType = true;
    if (!workEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      newErrors.workEmail = true;
    if (!monthlyIncome.match(/^[\d,]+$/)) newErrors.monthlyIncome = true;
    if (!work_pincode.match(/^\d{6}$/)) newErrors.work_pincode = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const allValid =
      companyName.trim() &&
      companyType &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(workEmail) &&
      /^\d+$/.test(monthlyIncome.replace(/,/g, "")) &&
      /^\d{6}$/.test(work_pincode);

    setIsFormValid(allValid);
  }, [companyName, companyType, workEmail, monthlyIncome, work_pincode]);

  console.log("Professional formData:", formData);

  const handleContinue = async () => {
    if (!validate()) return;
    const plainMonthlyIncome = monthlyIncome.replace(/,/g, "");
    const updated = {
      companyName,
      companyType,
      workEmail,
      monthlyIncome: plainMonthlyIncome,
      work_pincode,
      stepDone: 3,
    };

    setFormData((prev) => ({
      ...prev,
      ...updated,
    }));

    console.log("Form Data after Professional Info:", {
      ...formData,
      ...updated,
    });
    try {
      // API call to save/update lead
      console.log(leadFromStore)
      const res = await callApi(
        `v1/lead/${leadIdFromStore}/update-lead-new`,
        "post",
        {
          lead: {
            company_name: companyName,
            company_type: companyType,
            work_contact_email: workEmail,
            monthly_income: Number(monthlyIncome.replace(/,/g, "")),
            work_pincode: work_pincode,
            steps_completed: 3,
          },
        },
        "core",
        user?.token || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
      );

      if (res?.status === "Success") {
        toast.success("Form data updated successfully");

        // Step 5: Move to next step ONLY on successful API response
        setCurrentStep((prev) => prev + 1);
      } else {
        toast.error(res?.message || "Failed to update form data");
      }
    } catch (error) {
      console.error("Error updating lead:", error);
      toast.error("Something went wrong while updating form data");
    }
    // setUserClickData({
    //   event_name: "professional-details-submit-for-pl-non-pan",
    //   user_id: formData.mobile || "No User ID found here",
    //   affiliate_id: affId || "No Aff_id found",
    // });
   
  };

  useEffect(() => {
    if (formData) {
      setCompanyName(formData.companyName || "");
      setCompanyType(formData.companyType || "");
      setWorkEmail(formData.workEmail || "");
      setMonthlyIncome(formData.monthlyIncome || "");
      setwork_pincode(formData.work_pincode || "");
    }
  }, []);

  return (
    <div className="professional-details-container-v3">
      <h2 className="form-title" style={{ paddingLeft: "4px" }}>
        Professional information
      </h2>
      <p className="form-subtitle" style={{ paddingLeft: "4px" }}>
        You're just a few steps away from your ideal loan!
      </p>
      <div className="professional-details-input">
        <FormInputStyle2
          label="Company Name"
          value={companyName}
          id="companyName"
          onChange={(e) => {
            const sanitizedInput = sanitizeCompanyName(e.target.value);
            setCompanyName(sanitizedInput);
            if (errors.companyName)
              setErrors((prev) => ({ ...prev, companyName: false }));
          }}
          onBlur={() => {
            if (!companyName.trim())
              setErrors((prev) => ({ ...prev, companyName: true }));
          }}
          isValid={!errors.companyName}
          errorMessage="Company name is required"
        />

        <FormSelectStyle2
          label="Company Type"
          value={companyType}
          id="companyType"
          onChange={(val) => {
            setCompanyType(val);
            if (errors.companyType)
              setErrors((prev) => ({ ...prev, companyType: false }));
          }}
          onBlur={() => {
            if (!companyType)
              setErrors((prev) => ({ ...prev, companyType: true }));
          }}
          options={[
            { label: "Private Limited", value: "Private Limited" },
            { label: "Public Limited", value: "Public Limited" },
            {
              label: "Limited liability partnership (LLP)",
              value: "Limited liability partnership (LLP)",
            },
            { label: "Partnership", value: "Partnership" },
            { label: "Proprietorship", value: "Proprietorship" },
            { label: "Government", value: "Government" },
            { label: "One Person Company", value: "One Person Company" },
          ]}
          isValid={!errors.companyType}
          errorMessage="Please select company type"
        />

        <FormInputStyle2
          label="Work Email Address"
          value={workEmail}
          id="workEmail"
          onChange={(e) => {
            const { value, isValid } = sanitizeAndValidateEmail(e.target.value);
            setWorkEmail(value);
            setErrors((prev) => ({ ...prev, workEmail: !isValid }));

            if (errors.workEmail)
              setErrors((prev) => ({ ...prev, workEmail: false }));
          }}
          onBlur={() => {
            if (!workEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
              setErrors((prev) => ({ ...prev, workEmail: true }));
            }
          }}
          isValid={!errors.workEmail}
          errorMessage="Enter a valid work email"
        />

        <FormInputStyle2
          label="Monthly Income"
          value={
            monthlyIncome
              ? Number(monthlyIncome.replace(/,/g, "")).toLocaleString("en-IN")
              : ""
          }
          id="monthlyIncome"
          onChange={(e) => {
            let raw = e.target.value.replace(/,/g, ""); // Remove commas
            if (/^\d*$/.test(raw)) {
              // Ensure only numbers
              setMonthlyIncome(raw); // Store raw value (unformatted)
              if (errors.monthlyIncome) {
                setErrors((prev) => ({ ...prev, monthlyIncome: false }));
              }
            }
          }}
          onBlur={() => {
            if (!monthlyIncome.match(/^\d+$/)) {
              setErrors((prev) => ({ ...prev, monthlyIncome: true }));
            } else {
              // Format on blur
              setMonthlyIncome(Number(monthlyIncome).toLocaleString("en-IN"));
            }
          }}
          isValid={!errors.monthlyIncome}
          errorMessage="Enter valid income"
        />

        <FormInputStyle4
          label="Work Pin Code"
          value={work_pincode}
          onChange={(e) => handlePincodeChange(e.target.value)}
          onBlur={() => {
            if (!/^\d{6}$/.test(work_pincode) || errors.pincode) {
              setErrors((prev) => ({ ...prev, pincode: true }));
            }
          }}
          isValid={!errors.pincode}
          errorMessage="Enter a valid 6-digit PIN"
          tick={work_pincode.length === 6 && !errors.pincode}
          loading={pincodeValidation}
        />
      </div>
      <FormButtonStyle2
        text="Get My Offers"
        onClick={handleContinue}
        disabled={!isFormValid}
        id="btn-professional-details-landing-v4"
        className="tracking-btn-professional-details-landing-v4"
      />
    </div>
  );
};

export const getProfessionalFormData = () => {
  const data = {
    companyName: document.getElementById("companyName")?.value || "",
    companyType: document.getElementById("companyType")?.value || "",
    workEmail: document.getElementById("workEmail")?.value || "",
    monthlyIncome: document.getElementById("monthlyIncome")?.value || "",
    work_pincode: document.getElementById("work_pincode")?.value || "",
  };
  console.log("🔄 Collected Professional Form Data on Back:", data);
  return data;
};

export default ProfessionalDetailsForm;
